import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Routes from './Routes';
import ReactGA from 'react-ga';
ReactGA.initialize('UA-173012669-2');

ReactDOM.render(<Routes />, document.getElementById('root'));
